// src/configs/menuConfig.jsx - Versão atualizada
import roboWhite from "../assets/img/robot-white.png";
import roboBlack from "../assets/img/robot-black.png";
import CadeadoBlack from "../assets/svg/cadeado-black";
import PlusIcon from "../assets/svg/plusIcon";
import GestaoIcon from "../assets/svg/gestaoIcon";
import ListIcon from "../assets/svg/listIcon";
import DispositivoIcon from "../assets/svg/dispositivoICon";

// Configuração centralizada dos botões do menu
export const menuButtons = [
  {
    id: "Iluminacao",
    label: "Iluminação",
    page: "Iluminacao",
    hasSubmenu: true,
    submenuItems: [
      {
        id: "Terreo",
        label: "Térreo",
        page: "Térreo",
        requiresImage: true,
        imageIndex: 0,
        isAlarmPage: false
      },
      {
        id: "Lazer",
        label: "Lazer",
        page: "Lazer",
        requiresImage: true,
        imageIndex: 1,
        isAlarmPage: false
      },
    ],
    isLocked: false,
    order: 1
  },
  {
    id: "Exaustor",
    label: "Exaustores",
    page: "Exaustor",
    isLocked: true,
    lockIcon: CadeadoBlack,
    order: 2
  },
  {
    id: "Climatizacao",
    label: "Climatização",
    page: "Climatização",
    isLocked: true,
    lockIcon: CadeadoBlack,
    order: 3
  },
  {
    id: "Agendamentos",
    label: "Agendamentos",
    page: "Agendamentos",
    isLocked: false,
    order: 4
  },
  {
    id: "Monitoramento",
    label: "Monitoramento",
    page: "Alarme",
    hasSubmenu: true,
    submenuItems: [
      {
        id: "Bombas",
        label: "Bombas",
        page: "Bombas",
        requiresImage: false,
        imageIndex: 0,
        isAlarmPage: true // ✨ É página de alarme
      },
      {
        id: "CaixaDAgua",
        label: "Caixas D'Agua",
        page: "CaixaDAgua",
        requiresImage: false,
        imageIndex: 1,
        isAlarmPage: true // ✨ É página de alarme
      },
      {
        id: "CentralAlarmeIncendio",
        label: "Alarme de incendio",
        page: "CentralAlarmeIncendio",
        requiresImage: false,
        imageIndex: 3,
        isAlarmPage: true, // ✨ É página de alarme
        isLocked: process.env.REACT_APP_CIE_LOCKED !== 'false',
        lockIcon: CadeadoBlack,
      },
    ],
    isLocked: false,
    hasAlarmIndicator: true,
    order: 5
  },
  {
    id: "Registros",
    label: "Registros",
    page: "history",
    icon: ListIcon,
    iconProps: {
      className: "IconeMenu",
      width: "25",
      height: "25",
      getDynamicProps: (isActive) => ({ fill: isActive ? "#ffffff" : "#000000" })
    },
    isLocked: false,
    order: 6
  },
  {
    id: "Gestao",
    label: "Gestão",
    page: "Gestao",
    icon: GestaoIcon,
    iconProps: {
      className: "IconeMenu",
      width: "20",
      height: "20",
      getDynamicProps: (isActive) => ({ fill: isActive ? "#ffffff" : "#000000" })
    },
    isLocked: false,
    order: 7
  },
  {
    id: "",
    label: "",
    page: "",
    className: "invisivel",
    order: 8
  },
  {
    id: "PLUS",
    label: "PLUS",
    page: "PLUS",
    icon: PlusIcon,
    iconProps: { className: "PlusIcon", width: "25", height: "25" },
    isLocked: false,
    className: "plus-btn",
    order: 9
  },
  {
    id: "Chatbot",
    label: "Chatbot",
    page: "Chatbot",
    customIcon: (isActive) => (
      <img
        src={isActive ? roboWhite : roboBlack}
        alt="Robo"
        id="robo-icon"
      />
    ),
    isLocked: process.env.REACT_APP_CHATBOT_LOCKED !== 'false',
    lockIcon: CadeadoBlack,
    order: 10
  },
  {
    id: "RecursosExtras",
    label: "Recursos Extras",
    page: "RecursosExtras",
    hasSubmenu: true,
    submenuItems: [
      {
        id: "Dispositivos",
        label: "Dispositivos",
        page: "Dispositivos",
        icon: DispositivoIcon,
        iconProps: {
          className: "IconeMenu",
          width: "20",
          height: "20",
          getDynamicProps: (isActive) => ({
            fill: isActive ? "#3dbd12" : "#ffffff",
            stroke: isActive ? "#ffffff" : "#000000"
          })
        },
        isLocked: process.env.REACT_APP_DISPOSITIVOS_LOCKED !== 'false',
        lockIcon: CadeadoBlack,
        isAlarmPage: false // ✨ Não é página de alarme
      }
    ],
    isLocked: false,
    lockIcon: CadeadoBlack,
    order: 11
  }
];

// Função para obter botões ordenados
export const getMenuButtons = () => {
  return menuButtons.sort((a, b) => a.order - b.order);
};

// Configuração de páginas que requerem imagens
export const imagePages = {
  requiresImageClear: ["Agendamentos", "Alarme", "Exaustor", "Gestao", "Chatbot", "PLUS"]
};